import React from "react";

const BS5_GridExamples = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_GridExamples Component</h2>
      <p>This is the BS5_GridExamples component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_GridExamples;
